import React from 'react'

// Check 1 field trong form có được nhập, chọn giá trị hợp lệ hay không
export const checkValidFormFieldValue = val => {
  if (Array.isArray(val)) return val.length > 0
  if (typeof val === 'boolean') return val === true
  return val !== undefined && val !== null && val !== ''
}
